export const commonEnvironment = {
  version: '69ebc03d',
  authRealm: 'SIZ',
  authClientId: 'siz',
  teacherSupportUrl: 'https://siz.ch/handbuch',
  maxExcelUploadSizeMb: 10,
  clexHosts: ['clex-proxy-rds6', 'clex-proxy-rds7'],
  sentry: {
    dsn: undefined as string | undefined,
  },
  rdpClexHost: {
    'CLEXHOST6.clex.local': 'clex1.siz.ch',
    'CLEXHOST7.clex.local': 'clex2.siz.ch',
    'CLEXHOST8.clex.local': 'clex2.siz.ch',
  } as Record<string, string | undefined>,
  clexVmAccess: {
    waitIntervalMs: 5000,
    forceReevaluateAfterMs: 30000,
  },
  examExecution: {
    addParticipantsGracePeriod: 30,
  },
  goLiveDate: '2026-04-08T00:00:00Z',
};
